import config from "@/common/config.js"
import store from '@/store/index.js'
import {
	mapState,
	mapGetters
} from 'vuex'
import {
	verify
} from '@/common/verify.js'
import {
	UploadFileUrl
} from '@/common/api.js';

export default {
	data() {
		return {
			// 基础路径
			baseUrl: process.env.BASE_URL,
			// 接口域名
			configHost: config.host,
			// 上传文件地址
			uploadFileUrl: UploadFileUrl,
			// 网络图片前缀
			longText: '最近，谷歌发布了新的一篇论文介绍了一项新技术，使大语言模型能够处理无限长度的上下文。新论文声称可赋予大型语言模型（LLM）处理无限长度文本的能力。该论文介绍了无限注意力（Infini-attention），这是一种以扩展“上下文窗口”的方式配置语言模型的技术，同时保持内存和计算需求不变。',

		};
	},
	computed: {
		...mapState(['uInfo', 'dInfo']),
		...mapGetters(['isLogin'])
	},
	mounted() {

	},
	updated() {

	},
	filters: {

	},
	methods: {
		navigateBack(delta = -1) {
			window.history.length > 1 ? this.$router.go(delta) : this.$router.push('/')
		},
		//检测有无token
		checkUser() {
			if (!localStorage.getItem("token")) {
				return false
			}
			return true;
		},
		// 消息
		toast(options) {
			if (typeof options === "string") {
				this.$message({
					message: options,
					type: arguments[1] || 'warning',
				});
			} else {
				this.$message({
					message: '',
					type: '',
					customClass: '',
					...options
				});
				// success回调
				if (options.success) {
					setTimeout(() => {
						options.success()
					}, 1500)
				}
			}
		},
		// 校验
		verifyVal(options) {
			return verify(options)
		},
		// 手动处理富文本中的 px 单位
		px2rem(html) {
			if (!html) return ''
			return html.replace(/(\d+)px/g, (match, p1) => {
				return (p1 / 144) + 'rem' // 144 根据你的设计稿调整
			})
		},
		//控制富文本图片大小
		formatRichText(html) {
			// 图片处理
			let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
				let processed = null;
				processed = match.replace(/\<img/g, '<img class="rich-img"');
				return processed;
			});
			return newContent;
		},
		// 返回上一页
		goBack() {
			if (window.history.length > 1) {
				this.$router.go(-1)
			} else {
				this.$router.push('/')
			}
		}
	},
}